import { Component} from '@angular/core';
import { AgRendererComponent } from '@root/node_modules/ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

interface ICustomCellRendererParams {
  deleteHandler: (data: any) => void;
  canDeleteRow: (data: any) => boolean;
}

@Component({
  selector: 'app-delete-button-cell-renderer',
  templateUrl: './delete-button-cell-renderer.component.html',
  styleUrls: ['./delete-button-cell-renderer.component.scss']
})
export class DeleteButtonCellRendererComponent implements AgRendererComponent {

  params: any;
  deleteHandler: (data: any) => void;
  canDeleteRow: (data: any) => boolean = () => false;

  agInit(params: ICellRendererParams & ICustomCellRendererParams) {
    this.params = params;
    this.deleteHandler = params.deleteHandler;
    this.canDeleteRow = params.canDeleteRow;
  }

  isDeletable() {
    return this.canDeleteRow(this.params.data);
  }

  /* If we don't implement and return false, the grid will rerender the cell when needed. Less efficient */
  refresh(params: ICellRendererParams & ICustomCellRendererParams): boolean {
    this.params = params;
    return true;
  }

  onClick(): void {
    this.deleteHandler(this.params.data);
  }
}
